import { render, staticRenderFns } from "./PresetPageCreate.vue?vue&type=template&id=8fb2adec&"
import script from "./PresetPageCreate.vue?vue&type=script&lang=ts&"
export * from "./PresetPageCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports